var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.LOADING
    ? _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { cols: "7" } },
                [_c("application-standalone-loader")],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "b-container",
        [
          _c("application-submitted", {
            ref: "applicationSubmittedModal",
            attrs: { "has-requested-documents": _vm.hasRequestedDocuments },
          }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { cols: "9" } },
                [
                  _c(_vm.appComponent, {
                    directives: [
                      {
                        name: "disable-all-inputs",
                        rawName: "v-disable-all-inputs",
                        value: _vm.APPLICATION_IS_LOCKED,
                        expression: "APPLICATION_IS_LOCKED",
                      },
                    ],
                    tag: "component",
                    attrs: {
                      "show-information-page": _vm.showInformationPage,
                      "invalid-steps": _vm.invalidSteps,
                      "show-errors": _vm.showErrors,
                    },
                    on: {
                      "update:showInformationPage": function ($event) {
                        _vm.showInformationPage = $event
                      },
                      "update:show-information-page": function ($event) {
                        _vm.showInformationPage = $event
                      },
                      "change-flow": _vm.handleChangeFlow,
                      "navigate-next": _vm.goNext,
                      "navigate-back": _vm.goPrev,
                      "navigate-edit": _vm.goEdit,
                      "disable-save": _vm.disableSave,
                      "show-errors": _vm.handleShowErrors,
                      save: function () {
                        _vm.UPDATE_APPLICATION()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "navigation-toolbar",
                        fn: function (navigationSlotBinds) {
                          return [
                            _c("navigation-toolbar", {
                              attrs: {
                                "can-go-back": _vm.canGoPrev,
                                "can-save": _vm.canGoNext,
                                "can-submit": _vm.canSubmit,
                                "is-summary-page": _vm.isSummaryPage,
                                submitting: _vm.submitting,
                                "is-submit-page": _vm.isSubmitPage,
                                "display-previous": !_vm.isGoalsPage,
                                "display-next":
                                  navigationSlotBinds.displayNext &&
                                  !(
                                    _vm.APPLICATION_IS_LOCKED &&
                                    _vm.isSubmitPage
                                  ),
                                saving: _vm.saving,
                              },
                              on: {
                                "show-errors": _vm.handleShowErrors,
                                save: function ($event) {
                                  return _vm.handleSave(navigationSlotBinds)
                                },
                                back: function ($event) {
                                  return _vm.handleBack(navigationSlotBinds)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }